<template>
    <div class="bouns_history">
        <div class="row_center_start">
            <text class="bouns_date">{{ item.createdAt }}</text>
        </div>
        <div class="row_center_between" style="width: 100%;">
            <div class="column_start_start order_reason_number_container">
                <text class="bouns_reason">{{ item.reason }}</text>
                <text class="order_number">{{ item.orderNumber }}</text>
            </div>
            <div class="row_center_end bouns_amount">
                <text class="bouns_decrease" v-if="item.decrease != 0">-{{ item.decrease }}</text>
                <text v-if="item.decrease !== 0 && item.increase !== 0">/</text>
                <text class="bouns_increase" v-if="item.increase != 0">+{{ item.increase }}</text>
            </div>
        </div>
        <div class="row_center_start">
            <text class="bouns_rp_number">{{ item.rpNumber }}</text>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.bouns_history {
    width: 90%;
    padding: 5px 0;
    border-bottom: 1px dotted #000;
}

.bouns_date {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    margin-bottom: 10px;
}

.order_reason_number_container {
    flex-grow: 1;
    overflow-y: auto;
    margin: 0 10px 10px 0;
}

.bouns_reason {
    font-size: 16px;
    font-weight: 400;
    color: #000;
    overflow: hidden;
    overflow-y: auto;
    word-break: break-all;
    white-space: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.order_number {
    font-size: 16px;
    font-weight: 400;
    color: #000;
    overflow: hidden;
    overflow-y: auto;
    word-break: break-all;
    white-space: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.bouns_amount {
    font-size: 18px;
    font-weight: 700;
    color: #000;
    flex-shrink: 0;
}

.bouns_decrease {
    color: #DF2E33;
}

.bouns_rp_number {
    color: #666666;
    font-size: 14px;
    font-weight: 400;
}
</style>
